import Vue from 'vue'

Vue.filter('treatTime', value => ('00:00' + value).slice(-5))
